import { useState } from "react";
import { motion } from "framer-motion";

export default function TransportForm() {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert("Form submitted successfully!");
  };

  return (
    <div className="flex flex-col md:flex-row gap-8 p-6 md:p-12">
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
        className="md:w-1/2"
      >
        <h2 className="text-xl md:text-3xl font-bold text-gray-800">Hizmetlerimizin Avantajları Nelerdir?</h2>
        <p className="mt-4 text-gray-600">Kocabay Tur olarak avantajlarımız saymakla bitmez, ama gelin bir kaç tanesine birlikte göz atalım:</p>
        <div className="space-y-4 mt-6">
          {[
            { title: "Deneyim ve Güvenilirlik", desc: "Uzun zamanlı deneyimimizle güvenilir bir partneriz." },
            { title: "Müşteri Memnuniyeti", desc: "Müşterilerimizin ihtiyaçlarına özel çözümler sunarız." },
            { title: "Güvenlik ve Konfor", desc: "Modern, bakımlı araçlarla rahat bir deneyim sunarız." },
          ].map((advantage, index) => (
            <div key={index} className="shadow-md p-4 rounded-lg border border-gray-200">
              <h3 className="text-lg font-semibold text-[#092049]">{advantage.title}</h3>
              <p className="text-gray-700 mt-2">{advantage.desc}</p>
            </div>
          ))}
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
        className="md:w-1/2 bg-white p-6 rounded-xl shadow-lg"
      >
        <h2 className="text-xl md:text-3xl font-bold text-gray-800">Taşımacılık Hizmetlerine İhtiyacınız mı var?</h2>
        <form onSubmit={handleSubmit} className="space-y-4 mt-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="text"
              placeholder="Adınız"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-600"
            />
            <input
              type="text"
              placeholder="Şirketiniz"
              name="company"
              value={formData.company}
              onChange={handleChange}
              className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-600"
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="email"
              placeholder="Mail adresiniz"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-600"
            />
            <input
              type="tel"
              placeholder="Telefon numaranız"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-600"
            />
          </div>
          <textarea
            className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-600"
            placeholder="Mesajınız"
            name="message"
            rows={4}
            value={formData.message}
            onChange={handleChange}
          />
          <button type="submit" className="w-full bg-black text-white py-2 rounded-md hover:bg-gray-800">
            Formu Gönder
          </button>
        </form>
      </motion.div>
    </div>
  );
}
